module.exports = __webpack_public_path__ + "static/img/pro-card-bg.808cf23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pro-card-bg.png
// module id = 0Fc1
// module chunks = 27